// extracted by mini-css-extract-plugin
export default {"box":"style_box__bk-9x","box__header":"style_box__header__4U1ve","box__body":"style_box__body__lsswW"};